import React from 'react'
import { Grid } from 'semantic-ui-react'
import MatchesPage from './MatchesPage'
import ChatChartTabs from './ChatChartTabs'
import OnlinePlayers from './OnlinePlayers'
import { connect } from 'react-redux'

export class HostPage extends React.Component {


    componentDidMount() {
        if (this.props.onMount)
            this.props.onMount()
    }

  

    render() {
        const { socket } = this.props
        if (this.props.editMatchId) {
            return (
                <Grid columns={1} style ={{marginLeft:'5px', marginRight:'5px'}}>
                    <Grid.Column>
                        <MatchesPage socket={socket} />
                    </Grid.Column>
                </Grid>
            )
        }else {
            return (
                <Grid columns={2} style ={{marginLeft:'5px', marginRight:'5px'}}>
                    <Grid.Column>
                        <MatchesPage socket={socket} />
                    </Grid.Column>
                    <Grid.Column>
                        <OnlinePlayers /> 
                        <ChatChartTabs  game_id ={null} chatEnabled ={true}/>
                    </Grid.Column>
                </Grid>
            )
        }
    }
}

const mapStateToProps = (state, {}) => ({
    editMatchId: state.editMatchId
})

export default connect(
    mapStateToProps,
)(HostPage)


// WEBPACK FOOTER //
// ./src/components/HostPage.js